import { GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { convertForPersistence } from "client/Features/Search/RecentSearch/Persistence/convertForPersistence";
import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { ISearchResultItem } from "client/Features/Search/SearchResults/MultiScopeSearch/MultiScopeSearch";
import { ensureNotNil, isNotNil } from "client/Misc/utils";
import { useMemo } from "react";

type PersistedRecentlyOpenedItemConfigurationProps = {
	recentlyOpenedItem: GlobalSearchItemPersistedModel;
};

type NewRecentlyOpenedItemConfigurationProps = {
	searchResult: ISearchResultItem;
	itemScope: GlobalSearchScopeIdentifier;
};

export type RecentlyOpenedItemConfigurationProps =
	| PersistedRecentlyOpenedItemConfigurationProps
	| NewRecentlyOpenedItemConfigurationProps;

export function useResolveRecentlyOpenedItemForPersistence(props: RecentlyOpenedItemConfigurationProps): GlobalSearchItemPersistedModel {
	let recentlyOpenedItem: GlobalSearchItemPersistedModel | undefined = undefined;
	let searchResult: ISearchResultItem | undefined = undefined;
	let itemScope: GlobalSearchScopeIdentifier | undefined;

	if (isPersisted(props)) {
		recentlyOpenedItem = props.recentlyOpenedItem;
	} else {
		({ searchResult, itemScope } = props);
	}

	return useMemo(
		(): GlobalSearchItemPersistedModel => {
			if (isNotNil(recentlyOpenedItem)) {
				return recentlyOpenedItem;
			}

			return convertForPersistence(
				ensureNotNil(searchResult),
				ensureNotNil(itemScope)
			);
		},
		[
			itemScope,
			recentlyOpenedItem,
			searchResult
		]
	);
}

function isPersisted(props: RecentlyOpenedItemConfigurationProps): props is PersistedRecentlyOpenedItemConfigurationProps {
	return isNotNil((props as PersistedRecentlyOpenedItemConfigurationProps).recentlyOpenedItem);
}